import { LikeOutlined } from "@ant-design/icons";
import { Col, Divider, Row, Space, Typography } from "antd";
import { useGetSearchSuggestions } from "../../ServertSideStates";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useNavigate } from "react-router-dom";
import { handleResetAdvertListFilter, handleSetAdvertListFilter } from "apps/RealState/ListItems/ClientStates";
import CustomNoData from "apps/Common/CustomNoData";

import { useQueryClient } from "react-query";

interface SearchSuggestionProps {
  searchKey: string;
  setSearchKey:any
  setSearchTerm:any,
  setSearchContainerHeight:any,

}

const SearchSuggestion: FC<SearchSuggestionProps> = ({ searchKey,setSearchTerm,setSearchKey,setSearchContainerHeight }) => {
  const { Text } = Typography;
  const queryClient = useQueryClient()
  const searchSuggestions = useGetSearchSuggestions(searchKey);
  const {filter} = useSelector((state:RootState)=>state.realState)
  const dispatch = useDispatch()
  const navigate = useNavigate()



  

  return (
    <>
      <Row className=" !px-4 !py-2  ">
        <Col xs={24}>
          <Space>
            <LikeOutlined />
            <Text className="!font-bold !text-[#a0a3a9]">Öneriler</Text>
          </Space>
        </Col>
        {
          searchSuggestions?.data?.data?.categories.length>0?<>
          {searchSuggestions?.data?.data?.categories.map((item: any) => {
            console.log("item", item);
            return (
              <>
                <Col
                 onClick={async()=>{
                  const currentFilter = {...filter}

                  currentFilter["IsSearchFilter"] = true
                    await dispatch(handleResetAdvertListFilter())
                  await dispatch(handleSetAdvertListFilter({filter:currentFilter}))
                 
                  // navigate(`/ilan${item.type===0?"/gayrimenkul":"/arac"}/${item?.url}`)
                  navigate(`/ilan/${item?.url}`)
                  setSearchTerm("")
                  setSearchKey("")
                  

                }} 
                  xs={24}
                  className=" !px-4 !py-2 hover:!bg-[#f5f6f7] hover:cursor-pointer "
                  style={{ borderBottom: "1px solid #f5f6f7 " }}
                >
                
                    <Text 
                   
                    className="!text-xs">{item?.breadCrumb || ""}</Text>
              
                </Col>
                <Col xs={24}>
                  <Divider className="!m-0" />
                </Col>
              </>
            );
          }) || []}
          
          </>:<>
          <CustomNoData description="Önerilen Sonuç Bulunamadı" />
          </>
        }
      </Row>
    </>
  );
};

export default SearchSuggestion;
